import type { RewardFilterType } from "@jti/rest-api-types";

export const getIsVirtualFlag = (type: RewardFilterType | undefined): "0" | "1" | undefined => {
  switch (type) {
    case "virtual":
      return "1";
    case "sensorial":
      return "0";
    default:
      return undefined;
  }
};
